/**
 * Соответствие типов слоёв протокола именам виджетов.
 *
 * Здесь, в общем пакете, а не в оверлее и панели по отдельности:
 * предпросмотр обязан рисовать слой тем же виджетом, что и эфир.
 * Две таблицы разошлись бы при добавлении типа, и модератор увидел
 * бы одно, а зритель другое.
 */
import { LayerType } from '@owm/protocol';
/**
 * Переводит значение типа слоя в имя виджета.
 *
 * Соответствие ВЫВОДИТСЯ из перечисления, а не описывается таблицей.
 * Таблица разошлась бы с протоколом при добавлении типа, причём
 * молча: новый слой просто не рисовался бы, и причину искали бы
 * в виджетах. Ровно та же причина, по которой на сервере это тоже
 * вывод, а не таблица (hub/internal/scenes).
 */
export function typeName(type) {
    const name = LayerType[type];
    if (name === undefined) {
        return `unknown:${String(type)}`;
    }
    return name.toLowerCase();
}
//# sourceMappingURL=widgets.js.map